import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import Text from 'components/Text/Text';
import style from './TLSInfo.module.scss';

const TLSInfo: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<>
			{restaurantForFullInfo?.tlsCertificateLevel === 'Restaurant' && <FullInfoField label="certificate.p12" />}
			{restaurantForFullInfo?.tlsCertificateLevel === 'Device' && (
				<Text
					translationNameSpace="form"
					translationKey="toUseThisOptionForDevicesIndividuallyOpenDeviceLevelAndSetPreferences"
					size="xs"
					theme="neutralLight"
					className={style.container}
				/>
			)}
		</>
	);
};

export default TLSInfo;
